export {
  default,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalTabs,
  ModalTabItem,
} from './Modal';
